export default __webpack_public_path__ + "static/en-2e0cb490f6360b417714c3d62c8ef7f2.png";